import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/user-60.jpg'
import _imports_1 from '@/assets/images/user-52.jpg'
import _imports_2 from '@/assets/images/user-54.jpg'
import _imports_3 from '@/assets/images/user-55.jpg'
import _imports_4 from '@/assets/images/user-56.jpg'
import _imports_5 from '@/assets/images/user-61.jpg'
import _imports_6 from '@/assets/images/user-62.jpg'
import _imports_7 from '@/assets/images/user-63.jpg'
import _imports_8 from '@/assets/images/user-64.jpg'
import _imports_9 from '@/assets/images/user-66.jpg'
import _imports_10 from '@/assets/images/user-67.jpg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_6 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_7 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_8 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_9 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_10 = { class: "card-body p-4" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_12 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_13 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_14 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_15 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_16 = { class: "card-body p-4" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_18 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_19 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_20 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_21 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_22 = { class: "card-body p-4" }
const _hoisted_23 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_24 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_25 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_26 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_27 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_28 = { class: "card-body p-4" }
const _hoisted_29 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_30 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_31 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_32 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_33 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_34 = { class: "card-body p-4" }
const _hoisted_35 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_36 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_37 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_38 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_39 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_40 = { class: "card-body p-4" }
const _hoisted_41 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_42 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_43 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_44 = { class: "col-xxl-3 col-lg-4 col-sm-6" }
const _hoisted_45 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_46 = { class: "card-body p-4" }
const _hoisted_47 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_48 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_49 = { class: "d-flex flex-wrap justify-content-center mb-3" }
const _hoisted_50 = { class: "col-lg-12" }
const _hoisted_51 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_52 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_0 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Ava Turner</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#f3e8ff"}
          }, " Project Management ", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "85%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "85",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"85%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_5 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Ethan Parker</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[10] || (_cache[10] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#daebff"}
          }, "eCommerce Theme", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "45%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "45",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"45%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_6 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Isabella</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[20] || (_cache[20] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[27] || (_cache[27] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#d8ffc8"}
          }, "Shopify Theme Dev", -1)),
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "70%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "70",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"70%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_7 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Thompson</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[30] || (_cache[30] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[37] || (_cache[37] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#ffe8d4"}
          }, "Oito - HTM", -1)),
          _cache[38] || (_cache[38] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "90%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "90",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"90%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[41] || (_cache[41] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_8 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Lucas</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[40] || (_cache[40] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#d8ffc8"}
          }, "Tanus - Template", -1)),
          _cache[48] || (_cache[48] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "75%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "75",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"75%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[51] || (_cache[51] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_8 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Morgan</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_36, [...(_cache[50] || (_cache[50] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[57] || (_cache[57] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#f3e8ff"}
          }, "Delft - TypeScript", -1)),
          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "65%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "65",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"65%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[61] || (_cache[61] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_9 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Sophia</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[60] || (_cache[60] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[67] || (_cache[67] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#daebff"}
          }, "Trezo - Angular", -1)),
          _cache[68] || (_cache[68] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[69] || (_cache[69] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "95%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "95",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"95%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _cache[71] || (_cache[71] = _createStaticVNode("<div class=\"d-flex align-items-center\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_10 + "\" class=\"wh-65 rounded-circle border border-2\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h4 class=\"fs-16 fw-semibold mb-1\">Rodriguez</h4><span>Team Leader</span></div></div>", 1)),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[70] || (_cache[70] = [
              _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\">more_horiz</i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
            ]))])), [
              [
                _directive_b_tooltip,
                'More_Option',
                void 0,
                {
                  hover: true,
                  top: true
                }
              ]
            ])
          ]),
          _cache[77] || (_cache[77] = _createElementVNode("span", {
            class: "d-block py-2 px-3 text-center rounded-pill fw-medium text-secondary mb-3 bg-for-dark-mode",
            style: {"background-color":"#f3e8ff"}
          }, " eLearniv - React ", -1)),
          _cache[78] || (_cache[78] = _createElementVNode("span", { class: "d-block text-center text-body mb-3" }, "Team Members", -1)),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_RouterLink, { to: "/my-profile" }, {
              default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_RouterLink, {
              to: "/my-profile",
              class: "ms-m-15"
            }, {
              default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                _createElementVNode("img", {
                  src: _imports_4,
                  class: "wh-40 rounded-circle border border-2",
                  alt: "user"
                }, null, -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[79] || (_cache[79] = _createElementVNode("div", { class: "mb-4 pb-md-2" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between mb-2" }, [
              _createElementVNode("span", { class: "fw-medium d-block" }, "New Order"),
              _createElementVNode("span", { class: "fw-medium d-block" }, "80%")
            ]),
            _createElementVNode("div", {
              class: "progress bg-primary bg-opacity-10",
              style: {"height":"4px"},
              role: "progressbar",
              "aria-label": "Primary example",
              "aria-valuenow": "80",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"80%","height":"4px"}
              })
            ])
          ], -1)),
          _createVNode(_component_RouterLink, {
            to: "/project-management/project-overview",
            class: "btn btn-outline-primary fw-medium w-100 py-2 rounded-3"
          }, {
            default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
              _createTextVNode(" View Details ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_Pagination, {
            items: "8",
            total: "30"
          })
        ])
      ])
    ])
  ]))
}